export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const ERROR_MESSAGE = "Please enter a valid email.";
export const OTP_ERROR_MESSAGE = "OTP Code is Invalid";

export const PUBLIC_QUIZ_ID = 'local-publicQuizState';
export const PUBLIC_QUIZ_STATE_SUBMIT = 'local-publicQuizState-submit';
